import React from 'react';
import { Card, CardContent } from '@/components/ui';

export function SystemAlerts() {
  const alerts = [
    { id: '1', title: 'Dung lượng lưu trữ sắp đầy', desc: '85% dung lượng đã sử dụng', time: '10 phút trước', count: 1, type: 'critical' },
    { id: '2', title: 'Số lượng đăng nhập thất bại cao', desc: 'Phát hiện 15 lần đăng nhập thất bại', time: '30 phút trước', count: 3, type: 'warning' },
    { id: '3', title: 'Sao lưu chưa được thực hiện', desc: 'Lần sao lưu cuối: 12/05/2024 02:00', time: '1 giờ trước', count: 1, type: 'warning' },
  ];

  return (
    <Card className="border-none shadow-sm h-full flex flex-col">
      <CardContent className="p-6 flex-1 flex flex-col">
        <h3 className="text-sm font-bold text-slate-800 mb-6">Cảnh báo hệ thống</h3>
        
        <div className="flex-1 space-y-4">
          {alerts.map((alert) => (
            <div key={alert.id} className="flex justify-between items-start gap-4 p-3 rounded-xl bg-slate-50/50 border border-slate-100/50">
              <div className="flex gap-3 min-w-0">
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${alert.type === 'critical' ? 'bg-red-50 text-red-500' : 'bg-orange-50 text-orange-500'}`}>
                  <i className="ri-error-warning-line text-lg" />
                </div>
                <div className="min-w-0">
                  <p className="text-xs font-bold text-slate-700 truncate leading-tight mb-1">{alert.title}</p>
                  <p className="text-[10px] font-medium text-slate-400 leading-tight">{alert.desc}</p>
                </div>
              </div>
              <div className="flex flex-col items-end gap-2 shrink-0">
                <span className="text-[9px] font-bold text-slate-400 whitespace-nowrap">{alert.time}</span>
                <span className={`px-2 py-0.5 rounded-md text-[9px] font-normal text-white ${alert.type === 'critical' ? 'bg-red-500' : 'bg-orange-400'}`}>
                  {alert.count}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 pt-4 border-t border-slate-50">
          <button className="text-[10px] font-bold text-blue-500 flex items-center gap-1 hover:underline">
            Xem tất cả cảnh báo <i className="ri-arrow-right-line" />
          </button>
        </div>
      </CardContent>
    </Card>
  );
}
